import React, {useEffect, useState} from "react";
import {
  Grid
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  CheckboxWithLabel,
  FolderWithLabel,
  SimpleDialog,
  memoWithOpen,
} from "../../components";
import {addAssetFolder, pathWithExtension} from "../../utilities";
import path from "path";
import {useTaskQueue} from "../../hooks";
import {deleteAsset} from "../../redux/assets-slice";
import LocalScene from "../../viewer/js/projections";
import { useTranslation } from "react-i18next";

export const LasToSolv3dStreamable = memoWithOpen((props) => {
  const {assets, open, onClose} = props;
  const dispatch = useDispatch();
  const {addRunningTask} = useTaskQueue();
  const {t} = useTranslation();

  const [outputPath, setOutputPath] = useState(null);
  const [isSingleFile, setSingleFile] = useState(true);
  const [importResult, setImportResult] = useState(true);

  const canSubmit = (outputPath !== null);

  // TODO: actually handle multiple inputs (sent multiple exe commands to processing queue)
  const asset = assets ? assets[0] : undefined;

  const handleSubmit = () => {
    const pythonName = "process_las";
    const binPath = pathWithExtension(
      path.join(outputPath, "octree"), "bin");

    let commands = [
      "-p", pythonName,
      "--input_path", asset.path,
      "--output_folder", outputPath,
      "--single_file", isSingleFile,
      "--units", LocalScene.dataProjectionUnits
    ];

    const onFinish = async () => {
      if (!importResult) return;

      // Remove old LAS
      dispatch(deleteAsset(asset.id));

      // Add new streamable point cloud
      await addAssetFolder(dispatch, [binPath], asset.folderID);
    };

    onClose();
    addRunningTask(commands, onFinish);
  };

  const resetDefaults = () => {
    setOutputPath(null);
    setImportResult(true);
    setSingleFile(true);
  };

  useEffect(() => {
    if (open) return;
    resetDefaults();
  }, [open]);

  return (
    <React.Fragment>
      <SimpleDialog
        open={open}
        onClose={onClose}
        onSubmit={handleSubmit}
        canSubmit={canSubmit}
        title={t('functions.las_to_solv3d_streamable.title')}
        button={t('buttons.submit')}
      >
        <Grid container spacing={2}>

          {/** Single File */}
          <Grid item xs={6}>
            <CheckboxWithLabel
              title={t('export.streamable_cloud_version_2_0')}
              label={t('export.the_newest_version_of_the_streamable_point_cloud')}
              value={isSingleFile}
              onChange={setSingleFile}
            />
          </Grid>

          {/** Import results */}
          <Grid item xs={6}>
            <CheckboxWithLabel
              title={t('functions.import_results')}
              label={t('functions.las_to_solv3d_streamable.streamable_is_imported')}
              value={importResult}
              onChange={setImportResult}
            />
          </Grid>

          {/** Output folder */}
          <Grid item xs={6}>
            <FolderWithLabel
              title={t('point-markup.output-folder')}
              label={t('functions.las_to_solv3d_streamable.output_folder_for_solv3d_streamable')}
              value={outputPath}
              onChange={setOutputPath}
            />
          </Grid>
        </Grid>
      </SimpleDialog>
    </React.Fragment>
  );
});


